// هذا الملف يقوم بتحميل بيانات المستخدم من sessionStorage إلى Redux عند بدء التطبيق
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearState } from './redux/Slices/authSlice';

const useLoadAdminFromSession = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const storedUser = sessionStorage.getItem('adminkhadamat');
    if (storedUser && storedUser !== 'null') {
      try {
        const parsed = JSON.parse(storedUser);
        // إذا كان هناك بيانات وتوكن، خزّنها في الستور
        if (parsed && parsed.data && (parsed.data.token?.access_token || parsed.data.access_token)) {
          dispatch({ type: 'auth/loginUser/fulfilled', payload: parsed });
        }
      } catch {
        dispatch(clearState());
      }
    } else {
      dispatch(clearState());
    }
  }, [dispatch]);
};

export default useLoadAdminFromSession;
